import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

interface IProps {
    children: ReactElement | string;
}

export const FormDropdownItemTag = ({ children }: IProps): ReactElement => {
    return (
        <Text
            fontVariant="tag"
            color={colorsPalettes.carbon[0]}
            background={colorsPalettes.red[400]}
            borderRadius="16px"
            padding="4px 5px"
            height="16px"
        >
            {children}
        </Text>
    );
};
